import { environment } from '@environment/environment';

export function getApiUrl(path: string): string {
    return environment.apiUrl + path;
}
